import { DEFAULTS } from "./defaults.js";
import { GALLERY_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/nodeViewRenderers-loadable.js";
const pluginGallery = (config) => {
  return {
    config: { ...DEFAULTS.containerData, ...config },
    type: GALLERY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGallery
};
//# sourceMappingURL=viewer-loadable.js.map
